import { PAGE_HEADER_HEIGHT } from '@/catalog-apps/components/config'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/shadcn/breadcrumb'
import { IconRightChevronOutline } from '@icons/IconRightChevronOutline'
import type { ReactNode } from 'react'
import { Link } from 'react-router'
// import { dagsterAppsMockData } from './PlatformDagsterPage/dagsterAppsMockData'

export function AgentStudioBreadcrumbs({
  title,
  agentName,
  children,
}: {
  title: string
  agentName?: string
  children?: ReactNode
}) {
  return (
    <div
      style={{ height: PAGE_HEADER_HEIGHT }}
      className="sticky top-0 z-20 flex w-full items-center justify-between gap-10 border-b bg-offwhite/80 py-2 backdrop-blur"
    >
      <Breadcrumb className="backdrop-blur">
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbPage>Agent studio</BreadcrumbPage>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <IconRightChevronOutline />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            {agentName ? (
              <BreadcrumbLink asChild>
                <Link className="hover:text-primary hover:underline" to="/agent-studio/agents">
                  {title}
                </Link>
              </BreadcrumbLink>
            ) : (
              <BreadcrumbPage>{title}</BreadcrumbPage>
            )}
          </BreadcrumbItem>
          {agentName && (
            <>
              <BreadcrumbSeparator>
                <IconRightChevronOutline />
              </BreadcrumbSeparator>
              <BreadcrumbItem>
                <BreadcrumbPage>{agentName}</BreadcrumbPage>
              </BreadcrumbItem>
            </>
          )}
        </BreadcrumbList>
      </Breadcrumb>
      {children}
    </div>
  )
}
